<template>
    <div class="sub-container sv_page">

		<div class="info_container">
			<div class="service-intro">
				<div class="tit-img">
					<div class="tit-txt">
						그레이트 프로 <br />
						서비스
						<span>
							검증된 실력의 IT 프로와 프로젝트, 기업이 <br />
							모두 성공하는 서비스가 시작됩니다.
						</span>
					</div>
					<img src="/images/service-img-01.png" class="img">
				</div>

				<div class="greatpro-is">
					금융IT 프로 얼라이언스 플랫폼, 그레이트 프로 <br />
					IT프로, 기업, 프로젝트 모두 성공할 수 있습니다
				</div>

				<div class="step-3">
					<div class="title">
						그레이트 프로 인재 경쟁력, 3단계 검증 시스템
					</div>
					<div style="display: flex; flex-direction: row; justify-content: space-around;">
						<div class="step-box">
							<div class="circle">
								<span>1단계</span>
								인재<br />
								정보관리
							</div>
							<div class="point-txt">
								<ul>
									<li>정보 등록 및 업무협약</li>
									<li>개인정보 제공동의 등 계약서 작성</li>
									<li>직무 능력별 수시 보상</li>
								</ul>
							</div>
						</div>
						<div class="step-box">
							<div class="circle">
								<span>2단계</span>
								인재<br />
								성과평가
							</div>
							<div class="point-txt">
								<ul>
									<li>경력 증빙, NCS 직무평가</li>
									<li>전문가 인터뷰 등 <br />(기술·직무·인성·성과평가)</li>
								</ul>
							</div>
						</div>
						<div class="step-box">
							<div class="circle">
								<span>3단계</span>
								인재<br />
								사업참여
							</div>
							<div class="point-txt">
								<ul>
									<li>필요 IT 프로의 사전 검색</li>
									<li>IT 프로 예약·가계약 지원</li>
									<li>IT 프로에 대한 지속적 관리</li>
								</ul>
							</div>
						</div>
					</div>
				</div>

				<div class="greatpro-point">
					<div class="title">
						검증된 인재가 성공의 결과입니다
					</div>
					<div style="display: flex; flex-direction: row; justify-content: center;">
						<div class="box-point">
							<div class="circle01">
								IT <br />
								프로
							</div>
							<div class="point-txt">
								<div>
									검증된 <br />
									IT 프로 공급
								</div>
								<ul>
									<li>기술 경력 자동 계산 및 검증</li>
									<li>직무능력 수준 평가</li>
									<li>다면 검증과 평가 우수 인재 공급</li>
								</ul>
							</div>
						</div>
						<div class="box-point">
							<div class="circle02">
								그레이트 <br />
								프로
							</div>
							<div class="point-txt">
								<div>
									제휴 공급사 <br />
									우수자원 공유
								</div>
								<ul>
									<li>우수한 제휴사 인력 공급</li>
								</ul>
							</div>
						</div>
						<div class="box-point">
							<div class="circle03">
								클라이언트
							</div>
							<div class="point-txt">
								<div>
									그레이트 프로의 <br />
									퀄리티 보증
								</div>
								<ul>
									<li>프로엔 솔루션 교육지원</li>
									<li>기술인증서 발급</li>
									<li>관리자의 꾸준한 품질관리</li>
								</ul>
							</div>
						</div>
					</div>
				</div>

				<div class="greatpro-level">
					<div class="title">
						IT 프로의 등급은 어떻게 확정되나요?
					</div>
					<div class="sub-tit">
						그레이트 프로는 IT 업계에서 가장 객관적인 등급 평가 및 성과 다면 평가시스템을 가동합니다
					</div>
					<div style="display: flex; flex-direction: row; justify-content: center; margin-top: 10px">
						<div class="level-box">
							<div class="level-num">
								1. 경력 평가
								<ul>
									<li>기술 경력 등록</li>								
								</ul>
								<span>▶ 학력/경력/자격증</span>
							</div>
							<div class="level-btn" style="display: flex; flex-direction: row;">
								<div style="background-color: #000;
								color: #fff;
								font-family: Pretendard-Bold;
  								font-size: 25px;
								width: 228px;
								height: 34px;
								text-align: center;
								display: flex;
								align-items: center;
								justify-content: center;">시스템 평가</div>
								<div style="display: flex;
									height: 34px;
									width: 34px;
									text-align: center;
									align-items: center;
									justify-content: center;">
									<img src="/images/icon_arrow-intro.png">
								</div>
							</div>
						</div>
						<div class="level-box">
							<div class="level-num">
								2. 등급 산정
								<ul>
									<li>직무능력자가평가</li>								
								</ul>
								<span>▶ NCS 직무기술</span>
							</div>
							<div class="level-btn" style="display: flex; flex-direction: row;">
								<div style="background-color: #000;
								color: #fff;
								font-family: Pretendard-Bold;
  								font-size: 25px;
								width: 228px;
								height: 34px;
								text-align: center;
								display: flex;
								align-items: center;
								justify-content: center;">셀프 평가</div>
								<div style="display: flex;
									height: 34px;
									width: 34px;
									text-align: center;
									align-items: center;
									justify-content: center;">
									<img src="/images/icon_arrow-intro.png">
								</div>
							</div>
						</div>
						<div class="level-box">
							<div class="level-num">
								3. 등급 평가
								<ul>
									<li>기술/직무능력 평가 및 확정</li>								
								</ul>
							</div>
							<div class="level-btn" style="display: flex; flex-direction: row;">
								<div style="background-color: #000;
								color: #fff;
								font-family: Pretendard-Bold;
  								font-size: 25px;
								width: 228px;
								height: 34px;
								text-align: center;
								display: flex;
								align-items: center;
								justify-content: center;">매칭 매니저 평가</div>
								<div style="display: flex;
									height: 34px;
									width: 34px;
									text-align: center;
									align-items: center;
									justify-content: center;">
									<img src="/images/icon_arrow-intro.png">
								</div>
							</div>
						</div>
						<div class="level-box">
							<div class="level-num">
								4. 성과 다면 평가
								<ul>
									<li>업무 관련 지식,기술,태도,성과 등</li>
									<li>고객사 및 매칭 매니저와 다면평가</li>
								</ul>								
							</div>
							<div class="level-btn" style="display: flex; flex-direction: row;">
								<div style="background-color: #000;
								color: #fff;
								font-family: Pretendard-Bold;
  								font-size: 25px;
								width: 228px;
								height: 34px;
								text-align: center;
								display: flex;
								align-items: center;
								justify-content: center;">스페셜 리스트 선정</div>
								
							</div>
						</div>
					</div>
				</div>

				<div class="membership">
					<div class="title">
						그레이트 프로 회원 혜택
					</div>
					<div class="sub-tit">
						프로젝트 참여 중이거나 프로젝트를 완성한 그레이트 프로의 IT 프로들을 위한 <br />
						비즈니스 지원부터 커뮤니티 활동 지원까지 다른 어느 곳에서도 찾기 힘든 다양한 혜택을 준비했습니다.
					</div>

					<div class="benefit">
						<div>
							<div class="benefit01">
								비즈니스 <br >
								지원
							</div>
							<div class="benefit-txt">
								<ul>
									세무 및 법무 지원
									<ol>
										<li>세무대행 할인 서비스 (일반 IT 프로 회원 5만원 할인)</li>
										<li>법률 상담 서비스 (계약서 검토 및 작성, 분쟁 상담)</li>
									</ol>
								</ul>
							</div>
						</div>
						<div>
							<div class="benefit02">
								라이프케어 <br >
								지원
							</div>
							<div class="benefit-txt">
								<ul>
									건강 및 복지 지원
									<ol>
										<li>건강검진 지원 (제휴병원 할인 또는 10만원 지원)</li>
										<li>무료 심리상담 서비스 (프로젝트당 1회 무료, 번아웃 &middot; 스트레스 관리)</li>
										<li>2대 보험 보장 (고용보험, 산재보험 지원)</li>
										<li>그레이트 인센티브 : 프로필 완성 + 성공 보상금 (일반 50만원, 스페셜 100만원)</li>
									</ol>
								</ul>
							</div>
						</div>
						<div>
							<div class="benefit03">
								네트워킹 <br >
								지원
							</div>
							<div class="benefit-txt">
								<ul>
									성공을 위한 네트워킹 지원
									<ol>
										<li>IT 프로의 성공을 위한 정기 모임 무료 참석권 (연 4회)</li>
										<li>'그레이트 프로 멘토링 프로그램' 참여</li>
										<li>연말 '그레이트 프로 어워드' 선정자격 및 시상식 참여</li>
									</ol>
								</ul>
							</div>
						</div>
						<div>
							<div class="benefit04">
								스페셜 <br >
								IT 프로 우대
							</div>
							<div class="benefit-txt">
								<ul>
									업계 최고 수준 특별 지원
									<ol>
										<li>프로젝트 우선 매칭</li>
										<li>1:1 전담 매니저 배정</li>
										<li>세무대행 10만원 할인 서비스</li>
										<li>무료 심리상담 : 프로젝트당 1회, 연 1회 추가</li>
									</ol>
								</ul>
							</div>
						</div>
					</div>
				</div>

				<div class="greatpoint">
					<div class="title">
						그레이트 프로 포인트 및 현금 지급
					</div>
					<div class="tab_cont">
						<div class="tab_cont_inner">							
							<div class="tbl-view type2">
								<table>
									<colgroup>
										<col width="200" />
										<col width="200" />
										<col width="160" />
										<col width="300" />
										<col width="*" />
									</colgroup>
									<thead>
										<tr>
											<th>구분</th>
											<th>포인트 획득 조건</th>
											<th>지급 포인트</th>
											<th>포인트 지급 대상 회원</th>
											<th>포인트 현금 지급 시기</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td rowspan="4">IT 프로</td>
											<td>프로필 완성</td>
											<td>200,000 P</td>
											<td>프로필 기술등급 확정 IT프로 회원</td>
											<td rowspan="4">
												프로젝트 종료 및 <br />
												클라이언트 평가 완료 후 <br />
												적립포인트 일괄 지급
											</td>
										</tr>
										<tr>
											<td>인터뷰 완료</td>
											<td colspan="2">현장 인터뷰 참여비 10만원 지급</td>
										</tr>
										<tr>
											<td rowspan="2">프로젝트 완수</td>
											<td>300,000 P</td>
											<td>일반 IT 프로 회원</td>
										</tr>	
										<tr>											
											<td>800,000 P</td>
											<td>스페셜 IT 프로 회원</td>
										</tr>									
									</tbody>
								</table>						
							</div>
							<p class="text_type_as ta-left">
								※ 회원에 대한 지급포인트의 적정여부는 그레이트 프로에서 최종 확인합니다.<br />
								※ 포인트의 현금보상은 회원관리팀에서 최종 확인한 시점의 월말로 합니다. 
						    </p>
						</div>
					</div>
				</div>

				<div class="is-good">
					<div class="title">
						IT 프로젝트의 모든 기분 좋은일, 그레이트 프로에서 만나보세요
					</div>
					<div class="sub-tit">
						고객사의 행정사무, 특별한 보상, 그레이트 프로 책임보장까지, 그레이트 프로는 남다릅니다.
					</div>

					<div class="great-case">
						<div class="case">
							<div class="case-tit">
								<span>이보다 편할 수 없다</span>
								행정사무 솔루션
							</div>
							<div class="case-reward" style="border: none;">
								인재 수시 경력관리<br />
								인재 제출서류 자동검증<br />
								클라이언트 양식 이력서 출력<br />
								증빙서류 취합<br />
								각종 통계 자료 제공
							</div>
						</div>
						<div class="case">
							<div class="case-tit">
								<span>보상이 커서 좋다</span>
								그레이트 프로 보상혜택
							</div>
							<div class="case-reward">
								<span>IT 프로에게</span>
								프로필 완성 포인트 보상<br />
								인터뷰 완료 현금 지급<br />
								프로젝트 완수 포인트 보상
							</div>
							<div class="case-reward">
								<span>고객사에게</span>
								계약체결 보상<br />
								(계약누적건수 반영 이용료 할인)<br />
								성과평가 보상<br />
								(성과평가 실적 반영 이용료 할인)
							</div>
						</div>
						<div class="case">
							<div class="case-tit">
								<span>처음부터 끝까지</span>
								그레이트 프로 책임보장
							</div>
							<div class="case-reward">
								<span>IT 프로에게</span>
								조사, 분석, 평가<br />
								교육 수행, 면접 및 계약
							</div>
							<div class="case-reward">
								<span>고객사에게</span>
								서류, 계약, 이슈관리<br />
								프로젝트 모니터링, 사고대응
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		



		<!-- 정보입력폼 -->
		<!-- <div class="mem_container" v-if="$store.state.profile.name == '로컬'">
			<div class="mem_info_contents">
				<div class="mem_contents_header">
					<div class="title"><span class="mem_info"></span><p>개발가이드</p></div>
				</div>
				<div class="contents-body">
					<div class="Area">
						<div class="Item">
							<table class="tb">
								<colgroup>
									<col width="190">
									<col width="300">
									<col width="217">
								</colgroup>
								<tbody>
									<tr class="cursor" onclick="location.href='/pub/'">
										<th><span>*</span><label>퍼블</label></th>
										<td>/pub/</td>
									</tr>
									<tr class="cursor" v-for="depth1 in $store.state.menu.MENU_GUID" :key="depth1.menuId" @click="$router.move(depth1)">
										<th><span>*</span><label>{{depth1.menuNm}}</label></th>
										<td>{{depth1.menuId}}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>	
				</div>
			</div>
		</div>

        <div class="sub-contents" v-for="item in list" :key="item.id" :ref="item.id">
            <img :src="item.src" :alt="item.conts" :title="item.title"/>
        </div> -->
    </div>
</template>

<script>
import { serviceMeta } from '@/utils/meta';


export default {
	metaInfo : serviceMeta,
	data(){
		return {
			list : [
				{id   :'info01',
				 title: '',
				 src  : '/images/service01.png',
				 conts: '업계 최고의 금융IT 아웃소싱 서비스!\n성공적인 프로젝트를 위한 맞춤 인재 솔루션\n성공적인 프로젝트를 위하여 인재평가와 검증 및 관리를 통하여 검증된 IT전문인재들을 기업의 프로젝트와 연결해 드립니다.\n그레이트프로 인재관리 시스템은 성공적인 프로젝트를 위하여 인재평가와 검증 및 관리를 통하여 검증된 IT전문인재들을 기업의 프로젝트와 연결해주는 온라인 인재관리 시스템입니다.'},
				{id   :'info02',
				 title: '',
				 src  : '/images/service02.png',
				 conts: '검증된 프로젝트와 검증된 인재 연결 자율적 경력관리와 계약 체결 시 현금 보상 지속적인 인재 관리로 경쟁력 향상\n\n인적자원 등록 안내\n정보 등록 및 업무협약서 개인정보동의 등 계약서 작성 직무 능력별 수시 보상\n\n인적자원 평가 단계\n경력증빙, NCS직무평가 전문가 인터뷰 등 기술·직무·인성·성과평가\n\n인적자원 공급 단계\n우수인력 사전 검색 및 예약·가계약 지원 지속적인 전문 인력관리'},
				{id   :'info03',
				 title: '',
				 src  : '/images/service03.png',
				 conts: '검증된 IT 전문인재 공급\nIT프로: 기술경력, 직무능력, 실적자료 등록. 기술 및 직무경력 평가 및 보상\n\n수행사: 인재 검색 및 인터뷰 요청. 검증인재 추천·공급 및 보상\n\n1. 사전평가를 거친 전문인재 공급\n기술 경력 자동 계산 및 검증\n직무 능력 수준 평가\n업무수행 성과 평가 등\n다단계 검증과 평가 인력 공급\n\n2. 제휴사의 검증된 우수자원 공유\n제휴사의 검증된 인력 공유 활용\n\n3. 프로엔의 품질보증 지원 활동\n자질 향상을 위한 프로엔 교육 지원\n능력 평가에 따른기술 인증서 발급\n관리자 배정을 통한 꾸준한 품질관리'},
				{id   :'info04',
				 title: '',
				 src  : '/images/service04.png',
				 conts: '서비스소개04'},
				{id   :'info05',
				 title: '',
				 src  : '/images/service05.png',
				 conts: '서비스소개05'},
				{id   :'infoPoint',
				 title: '',
				 src  : '/images/service06.png',
				 conts: '서비스소개06'},
				{id   :'infoSafety',
				 title: '',
				 src  : '/images/service07.png',
				 conts: '서비스소개07'},
				{id   :'infoAS',
				 title: '',
				 src  : '/images/service08.png',
				 conts: '서비스소개08'},
			]
		}
	},
	mounted(){
		if(this.$route.query.target){
			this.$nextTick(() => this.focus(this.$route.query.target));
		}
	},
	methods:{
		focus(target){
			//console.log('focus', target);
			if(target && this.$refs[target]){
				this.$.focus(this.$refs[target]);
			}
		}
	}
}
</script>